import { EndpointKey } from './EndpointKey';
import { requestPurchaseProductInfo } from '../step-choose-seats/requestPurchaseProductInfo';
import { setHasSeatsChanged, setAdditionalSeats, setProductInfo, updateDtbIdInUrl } from '../store/purchase/action-creators';
import { Tracker } from '../store/tracking/action-creators';
import Logger from '../lib/Logger';
import { getSentryExtra } from '../error/getSentryExtra';
import { splitProductAndAdditional } from '../experiments/acq151/ACQ151Utils';
import { PurchaseActionTypes } from '../store/purchase/action-types';
import { requestUpdateDtbId } from '../step-choose-seats/requestUpdateDtbId';
import { ErrorKey } from '../app-active-error/ErrorKey';
import { setError } from '../store/error/action-creators';
import { getAcq151ActiveAndIsUsdPurchaseFlow } from '../store/purchase/selectors';
const LOG = Logger.getLogger('Acq151Endpoints');
export const EndpointsPurchaseSeatsACQ151 = {
  [EndpointKey.PurchaseProductInfo]: {
    isStateOnlyTrigger: true,
    once: true,
    stateCheck: state => {
      return getAcq151ActiveAndIsUsdPurchaseFlow(state);
    },
    method: requestPurchaseProductInfo,
    handleSuccess: (response, dispatch) => {
      const {
        products,
        additional
      } = splitProductAndAdditional(response.productsInfo);
      if (products.length === 1) {
        dispatch(setProductInfo(products[0]));
        if (additional.length === 1) {
          dispatch(setAdditionalSeats(additional[0].quantity, false));
        }
      } else {
        dispatch(Tracker.signupInteraction('acq0151-product-info-multiple-products'));
      }
    },
    handleError: (error, dispatch) => {
      const validationError = error && error.status === 400;
      dispatch(Tracker.signupInteraction(validationError ? 'error-acq0151-product-info-validation' : 'error-acq0151-product-info-general'));
      if (!validationError) {
        LOG.error('ACQ151 Product info error', {
          extra: getSentryExtra(error)
        });
      }
    }
  },
  [EndpointKey.PurchaseProductUpdateDtbId]: {
    reduxActionType: PurchaseActionTypes.UpdateDtbId,
    method: requestUpdateDtbId,
    handleSuccess: (response, dispatch) => {
      dispatch(Tracker.signupInteraction('choose-seats-updated-dtb-id'));
      dispatch(updateDtbIdInUrl(response.id));
      dispatch(setHasSeatsChanged(false));
    },
    handleError: (error, dispatch) => {
      LOG.error(`ACQ151 Error creating a new dbtId`, {
        extra: Object.assign({}, getSentryExtra(error))
      });
      dispatch(setError(ErrorKey.InvalidDtbIdError));
    }
  }
};